<template>
  <div class="compare-attributes-tutorials">
    Her er tekst for compare attributes tutorial
  </div>
</template>

<script>
export default {
  name: 'compare-attributes-tutorials',
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  @import '~@/components/sass/shared/colors';

  .compare-attributes-tutorials{}
</style>



// WEBPACK FOOTER //
// src/components/tutorials/CompareAttributesTutorial.vue